/* global swal:false */
(function() {
  'use strict';

  angular
    .module('admin.users.details.cash_ledgers.bundles', [])
    .controller('CashLedgersBundlesAdminCtrl', CashLedgersBundlesAdminCtrl);

  /** @ngInject */
  function CashLedgersBundlesAdminCtrl($stateParams, UsersService) {
    var vm = this;
    vm.items = [];
    vm.userId = $stateParams.parentId;
    vm.totalUsers = 0;
    vm.usersPerPage = 10;
    vm.oldPage = 0;
    vm.currentPage = 10;
    vm.first = true;
    vm.pagination = {
      current: 1
    }
    vm.setId = $stateParams.setId;
    vm.bundleId = $stateParams.bundleId;
    vm.bpId = $stateParams.bpId;

    UsersService.get($stateParams.parentId).then(function(result){
      vm.user = result.results;
    });

    UsersService.bundlePurchases($stateParams.parentId, vm.bpId).then(function(result){
      vm.items = result.results;
    });

    vm.export = function(){
      $('.print').hide();
      var html = '<!DOCTYPE html><head><link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css" integrity="sha384-BVYiiSIFeK1dGmJRAkycuHAHRg32OmUcww7on3RYdg4Va+PmSTsz/K68vbdEjh4u" crossorigin="anonymous"></head><body>' + $('#table').html() + '</body></html>';
      window.open().document.write(html);
      $('.print').show();
    };
  }

})();
